import { message } from 'antd';

const notifySuccess = ({ action, name }) => message.success(`${name} ${action.perfectPast}.`);

export default notifySuccess;
